export default __webpack_public_path__ + "images/RJ.aab6932.png";